// SHADOW MARKET™ — Grafické vzory
// Dátová vrstva pre 16 lekcií grafických vzorov zobrazených v Akadémii.

export const PATRONES = [
  {
    id: "bandera-alcista",
    nombre: "Vzostupná vlajka",
    tipo: "continuacion",
    direccion: "alcista",
    nivel: "basico",
    descripcion:
      "Pokračovací vzostupný vzor tvorený silným vzostupným impulzom (žrď) nasledovaným korekciou v paralelnom zostupnom kanáli (vlajka). Signalizuje pauzu pred tým, než trend pokračuje nahor.",
    estructura: [
      "Žrď: silný vzostupný impulz",
      "Paralelný zostupný korekčný kanál (vlajka)",
      "Prelom nahor z kanála s objemom",
    ],
    objetivo: "Výška žrde premietnutá nahor od bodu prelomu.",
    consejo:
      "Hľadaj klesajúci objem počas vlajky a nárast pri prelome. Spoľahlivejšie na 4H alebo dennom grafe. Veľmi časté na BTC po pozitívnych správach.",
  },
  {
    id: "bandera-bajista",
    nombre: "Zostupná vlajka",
    tipo: "continuacion",
    direccion: "bajista",
    nivel: "basico",
    descripcion:
      "Pokračovací zostupný vzor. Silný zostupný impulz (žrď) nasledovaný vzostupnou korekciou v paralelnom kanáli (vlajka). Signál pokračovania zostupného trendu.",
    estructura: [
      "Žrď: silný zostupný impulz",
      "Paralelný vzostupný korekčný kanál",
      "Prelom nadol z kanála",
    ],
    objetivo: "Výška žrde premietnutá nadol od bodu prelomu.",
    consejo:
      "Korekčný kanál by mal zostať pod 50 % žrde. Ak prekročí túto úroveň, vzor stráca spoľahlivosť.",
  },
  {
    id: "banderin-alcista",
    nombre: "Vzostupná vlajočka",
    tipo: "continuacion",
    direccion: "alcista",
    nivel: "basico",
    descripcion:
      "Podobné vzostupnej vlajke, ale korekcia tvorí konvergentný trojuholník namiesto paralelného kanála. Konsolidácia je kompaktnejšia a prelom býva výbušnejší.",
    estructura: [
      "Žrď: vzostupný impulz",
      "Konvergentný konsolidačný trojuholník",
      "Prelom nahor z trojuholníka",
    ],
    objetivo: "Výška žrde premietnutá od vrcholu trojuholníka nahor.",
    consejo:
      "Trojuholník by sa mal tvoriť v hornej polovici žrde. Čím bližšie k vrcholu je prelom, tým silnejší býva pohyb.",
  },
  {
    id: "banderin-bajista",
    nombre: "Zostupná vlajočka",
    tipo: "continuacion",
    direccion: "bajista",
    nivel: "basico",
    descripcion:
      "Zostupná verzia vlajočky. Konvergentný trojuholník sa tvorí po silnom zostupnom impulze. Signál pokračovania: prelom nadol potvrdzuje pohyb.",
    estructura: [
      "Žrď: zostupný impulz",
      "Konvergentný konsolidačný trojuholník",
      "Prelom nadol z trojuholníka",
    ],
    objetivo: "Výška žrde premietnutá nadol od vrcholu.",
    consejo:
      "Potvrď nárastom objemu pri prelome. Vlajočky na krátkych časových rámcoch (15min-1H) sú veľmi časté v krypte.",
  },
  {
    id: "taza-asa",
    nombre: "Šálka s uškom",
    tipo: "continuacion",
    direccion: "alcista",
    nivel: "intermedio",
    descripcion:
      "Jemná korekcia v tvare U (šálka) nasledovaná malou zostupnou konsolidáciou (uško). Jeden z najštudovanejších vzorov na vzostupných trhoch.",
    estructura: [
      "Predchádzajúci vzostupný impulz",
      "Korekcia v tvare U (šálka)",
      "Malá zostupná korekcia (uško)",
      "Prelom nad odpor",
    ],
    objetivo: "Hĺbka šálky premietnutá nahor od úrovne odporu.",
    consejo:
      "Šálka musí byť zaoblená (U), nie V. Uško by nemalo korigovať viac ako 50 % šálky. Veľmi časté na BTC na týždenných grafoch.",
  },
  {
    id: "taza-asa-invertida",
    nombre: "Obrátená šálka s uškom",
    tipo: "continuacion",
    direccion: "bajista",
    nivel: "intermedio",
    descripcion:
      "Zostupná verzia. Korekcia tvorí obrátenú kupolu nasledovanú malou vzostupnou korekciou. Signál pokračovania zostupného trendu.",
    estructura: [
      "Predchádzajúci zostupný impulz",
      "Korekcia v tvare obráteného U (kupola)",
      "Malá vzostupná korekcia (uško)",
      "Zostupný prelom podpory",
    ],
    objetivo: "Hĺbka kupoly premietnutá nadol od podpory.",
    consejo:
      "Časté na predĺžených zostupných trhoch. Potvrď rastúcim objemom pri prelome nadol.",
  },
  {
    id: "doble-techo",
    nombre: "Dvojité vrcholy",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "basico",
    descripcion:
      "Dva po sebe idúce maximá na rovnakej úrovni s medzivrcholom. Signál, že kupujúci nevedia prekonať tento odpor. Prelom pod líniu krku potvrdzuje obrat.",
    estructura: [
      "Prvé maximum",
      "Korekcia k línii krku",
      "Druhé maximum na rovnakej úrovni",
      "Zostupný prelom línie krku",
    ],
    objetivo: "Vzdialenosť medzi maximom a líniou krku, premietnutá nadol.",
    consejo:
      "Druhé maximum s nižším objemom zvyšuje spoľahlivosť. Potvrď uzavretím pod líniou krku.",
  },
  {
    id: "doble-suelo",
    nombre: "Dvojité dná",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "basico",
    descripcion:
      "Dve po sebe idúce minimá na rovnakej úrovni s medzivrcholom. Predajcovia nevedia stlačiť cenu pod túto podporu. Vzostupný prelom línie krku potvrdzuje obrat.",
    estructura: [
      "Prvé minimum",
      "Odraz k línii krku",
      "Druhé minimum na rovnakej úrovni",
      "Vzostupný prelom línie krku",
    ],
    objetivo: "Vzdialenosť medzi minimom a líniou krku, premietnutá nahor.",
    consejo:
      "Druhé minimum s nižším objemom je pozitívny signál. Potvrď uzavretím nad líniou krku.",
  },
  {
    id: "triple-techo",
    nombre: "Trojité vrcholy",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "intermedio",
    descripcion:
      "Tri maximá na rovnakej úrovni. Spoľahlivejšie než dvojité vrcholy. Každý neúspešný pokus prekonať odpor zvyšuje predajný tlak.",
    estructura: [
      "Tri po sebe idúce maximá na rovnakej úrovni",
      "Dve medzikrekcie",
      "Prelom pod líniu krku",
    ],
    objetivo: "Vzdialenosť medzi maximom a líniou krku, premietnutá nadol.",
    consejo: "Čím dlhšie trvá formovanie, tým silnejší býva následný pokles.",
  },
  {
    id: "triple-suelo",
    nombre: "Trojité dná",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "intermedio",
    descripcion:
      "Tri minimá na rovnakej úrovni. Jeden z najsilnejších signálov vzostupného obratu. Podpora sa posilňuje s každým odrazom.",
    estructura: [
      "Tri po sebe idúce minimá na rovnakej úrovni",
      "Dva medziodrazy",
      "Prelom nad líniu krku",
    ],
    objetivo: "Vzdialenosť medzi minimom a líniou krku, premietnutá nahor.",
    consejo:
      "V krypte trojité dná na dlhodobej podpore často označujú významné trhové dná.",
  },
  {
    id: "cabeza-hombros",
    nombre: "Hlava a ramená",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "basico",
    descripcion:
      "Najznámejší vzor obratu. Tri maximá: stredné (hlava) presahuje dve vonkajšie (ramená), ktoré sú na rovnakej úrovni. Prelom pod líniu krku potvrdzuje zostupný obrat.",
    estructura: [
      "Ľavé rameno",
      "Hlava (vyššie maximum)",
      "Pravé rameno (≈rovnaká úroveň ako ľavé)",
      "Línia krku + zostupný prelom",
    ],
    objetivo: "Vzdialenosť medzi hlavou a líniou krku, premietnutá od prelomu.",
    consejo:
      "Línia krku naklonená nahor je zostupnejšia. Vysoký objem pri prelome potvrdzuje vzor.",
  },
  {
    id: "cabeza-hombros-inversos",
    nombre: "Obrátené H&R",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "basico",
    descripcion:
      "Vzostupná verzia hlavy a ramien. Tri minimá, kde stredné (hlava) je najnižšie. Prelom nad líniu krku signalizuje silný vzostupný obrat.",
    estructura: [
      "Ľavé rameno",
      "Hlava (nižšie minimum)",
      "Pravé rameno (≈rovnaká úroveň ako ľavé)",
      "Línia krku + vzostupný prelom",
    ],
    objetivo: "Vzdialenosť medzi hlavou a líniou krku, premietnutá nahor.",
    consejo:
      "Jeden z najspoľahlivejších vzorov na identifikáciu dien. Hľadaj rastúci objem na pravom ramene a pri prelome.",
  },
  {
    id: "cuna-ascendente",
    nombre: "Vzostupný klin",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "intermedio",
    descripcion:
      "Konvergentný kanál naklonený nahor. Obe línie stúpajú, ale konvergujú: cena má čoraz menej priestoru na rast. Signál zostupného obratu.",
    estructura: [
      "Vzostupná odporová línia",
      "Vzostupná podporná línia (so strmším sklonom)",
      "Konvergencia oboch línií",
      "Prelom nadol",
    ],
    objetivo: "Výška základne klina premietnutá nadol od bodu prelomu.",
    consejo:
      "Vzostupné kliny sa často objavujú na konci vzostupných impulzov. Sú signálmi inštitucionálnej distribúcie.",
  },
  {
    id: "cuna-descendente",
    nombre: "Zostupný klin",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "intermedio",
    descripcion:
      "Konvergentný kanál naklonený nadol. Predajný tlak sa s každým minimom znižuje. Signál vzostupného obratu: prelom nahor býva silný.",
    estructura: [
      "Zostupná odporová línia",
      "Zostupná podporná línia (s miernejším sklonom)",
      "Konvergencia oboch línií",
      "Prelom nahor",
    ],
    objetivo: "Výška základne klina premietnutá nahor od bodu prelomu.",
    consejo:
      "Zostupné kliny v korekciách vzostupného trendu sú veľmi spoľahlivé signály pokračovania na BTC/ETH.",
  },
  {
    id: "triangulo",
    nombre: "Symetrický trojuholník",
    tipo: "neutro",
    direccion: "neutro",
    nivel: "basico",
    descripcion:
      "Konsolidačná zóna s klesajúcimi maximami a rastúcimi minimami. Cena sa stláča, kým energia nevytvorí prelom. Smer prelomu určuje cieľ.",
    estructura: [
      "Zostupná odporová línia",
      "Vzostupná podporná línia",
      "Konvergencia k vrcholu",
      "Prelom (neurčený smer)",
    ],
    objetivo: "Výška základne trojuholníka premietnutá v smere prelomu.",
    consejo:
      "Kontext určuje pravdepodobnosť: trojuholník vo vzostupnom trende zvyčajne prelomí nahor. Vždy potvrď uzavretím sviečky vonku.",
  },
  {
    id: "rectangulo",
    nombre: "Obdĺžnik",
    tipo: "neutro",
    direccion: "neutro",
    nivel: "basico",
    descripcion:
      "Cena osciluje medzi horizontálnou podporou a odporom. Zóna akumulácie alebo distribúcie. Smer prelomu určuje sklony a cieľ.",
    estructura: [
      "Horizontálny odpor",
      "Horizontálna podpora",
      "Oscilácie medzi oboma",
      "Prelom (neurčený smer)",
    ],
    objetivo: "Výška obdĺžnika premietnutá v smere prelomu.",
    consejo:
      "V krypte dlhé obdĺžniky s rastúcim objemom na minimách zvyčajne predchádzajú silným vzostupným prelomom (inštitucionálna akumulácia).",
  },
];

export const TIPOS = ["continuacion", "reversion", "neutro"];
export const NIVELES = ["basico", "intermedio"];

export const TIPO_LABEL = {
  continuacion: "Pokračovanie",
  reversion: "Obrat",
  neutro: "Neutrálny",
};

export const DIRECCION_LABEL = {
  alcista: "Vzostupný",
  bajista: "Zostupný",
  neutro: "Neutrálny",
};

export const NIVEL_LABEL = {
  basico: "Základný",
  intermedio: "Stredný",
};

export function getPatron(id) {
  return PATRONES.find((p) => p.id === id) || null;
}

export function filtrarPatrones(tipo, nivel) {
  return PATRONES.filter((p) => {
    if (tipo && tipo !== "todos" && p.tipo !== tipo) return false;
    if (nivel && nivel !== "todos" && p.nivel !== nivel) return false;
    return true;
  });
}